
import { Filtering } from './../../../../service/filtering/filtering';
import { environment } from './../../../../../environments/environment';
import { AfterViewInit, Component, computed, OnDestroy, OnInit, signal } from '@angular/core';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { Router } from '@angular/router';
import { FincasApiService } from '../../../../service/api/fincas-api.service';
import { StorageManager } from '../../../../common/storage-manager.class';
import { ItemInterface } from '../../../../common/components/form-builder/form-builder.component';
import { RequestHandler } from '../../../../service/OffService/request-handler';
import { RequestButtonTypes } from '../../../../common/components/request-button/request-button.component';
import { Utils } from '../../../../common/utils';
import { BaseView } from '../../../base-view';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { createCsv } from 'src/app/common/components/reactive-form-builder/export/createCsv';
import { firstValueFrom } from 'rxjs';

import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { FullMapModel } from 'src/app/models/form-common/full-map.model';
import { TreeNode } from 'primeng/api';
import { UsuariosApiService } from 'src/app/service/api/usuarios-api.service';
import { UserModel } from 'src/app/models/usuarios/user.model';
import { TareaSiembraModel } from 'src/app/models/tareas/tarea-siembra.model';
import { ParcelasFormDefinition } from './parcelas-form/form-definition';
import { ParcelasEnvironmentDefinition } from './environment-variables';
import { ParcelasListsDefinition } from './parcelas-form/list-variables';
import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { TrabajadoresApiService } from 'src/app/service/api/trabajadores-api.service';
import { MantenimientoModel } from 'src/app/models/trabajadores/mantenimiento.model';

declare const convierteEPSG: (coordenadas: string[]) => string;


@Component({
    selector: 'app-parcelas',
    standalone: false,
    templateUrl: './parcelas.component.html',
    styleUrls: ['./parcelas.component.scss']
})
export class ParcelasComponent extends BaseView<ParcelasModel> implements OnInit, AfterViewInit, OnDestroy {

    public form!: ParcelasFormDefinition;

    public env: ParcelasEnvironmentDefinition = new ParcelasEnvironmentDefinition();

    public lists: ParcelasListsDefinition = new ParcelasListsDefinition();

    public appName = environment.appName;

    public applicationType = environment.features.applicationType;

    public rol: string = StorageManager.getUser().rol;

    public activateApiSIEX = environment.features.activateSIEX;

    public showBotonPrintParcelas = environment.features.showBotonPrintParcelas;

    public showParcelasFincasCol = environment.features.showParcelasFincasCol;

    public showParcelasSector = environment.features.showParcelasSector;

    public showNumeroFincas = environment.features.showNumeroFincas;

    public showNombreParcela = environment.features.showNombreParcela;

    public showSectores = environment.features.showSectores;

    public showAplicadoresActivo = environment.features.showAplicadoresActivo;

    public canAddParcelas = environment.features.canAddParcelas;

    public canEditParcelas = environment.features.canEditParcelas;

    public canDeleteParcelas = environment.features.canDeleteParcelas;

    public fincaName = environment.features.fincaName;

    public fincasName = environment.features.fincasName;

    public sectorName = environment.features.sectorName;

    public sectoresName = environment.features.sectoresName;

    public parcelaName = environment.features.parcelaName;

    public parcelasName = environment.features.parcelasName;

    public showDatosMedioambientales = environment.features.showDatosMedioambientales;

    public showParcelasEstacion = environment.features.showParcelasEstacion;

    public showParcelasProvinciaCol = environment.features.showParcelasProvinciaCol;

    public showParcelasMunicipioCol = environment.features.showParcelasMunicipioCol;

    public showParcelasCodigoTrazabilidad = environment.features.showParcelasCodigoTrazabilidad;

    public showCampaign = environment.features.showTareasFertilizantesCampaign;

    public showParcelasTurbo = environment.features.showParcelasTurbo;

    public textoSuperficie = environment.features.textoSuperficie;

    public hasPlantas = environment.features.hasPlantas;

    public showCultivosVariedadesPropios = environment.features.showCultivosVariedadesPropios;

    tableMode = signal<'single' | 'multiple' | 'checkbox' | null>('single');

    multiSelect = signal<boolean>(false);

    selectedNodes = signal<TreeNode<ParcelasModel>[]>([]);

    selectParcelas = computed(() => this.selectedNodes().map(node => node.data));

    public responsables = signal<UserModel[]>([]);

    public selectedResponsable: UserModel | null = null;

    public assignToResponsibleOpened = false;

    public workersAdvisors = signal<MantenimientoModel[]>([]);

    public selectedAdvisor: MantenimientoModel | null = null;

    public assignToAdvisorOpened = false;

    public years = [
        { label: '...', value: '' },
        { label: '2020', value: '_2020_' },
        { label: '2021', value: '_2021_' },
        { label: '2022', value: '_2022_' },
        { label: '2023', value: '_2023_' },
        { label: '2024', value: '_2024_' },
        { label: '2025', value: '_2025_' },
        { label: '2026', value: '_2026_' },
        { label: '2027', value: '_2027_' },
        { label: '2028', value: '_2028_' },
        { label: '2029', value: '_2029_' },
        { label: '2030', value: '_2030_' },
    ];

    public selectedYears = '';

    public btnAnadir = `Añadir ${this.parcelaName}`;

    public filter: Filtering<ParcelasModel> = new Filtering<ParcelasModel>();

    public filterSiembra: Filtering<any> = new Filtering<any>();

    public getRequest: RequestHandler<ParcelasModel[]> = this.fincasApi.parcelasGET;

    public deleteRequest: RequestHandler<ParcelasModel> = this.fincasApi.parcelasDELETE;

    public menuItemId = 'parcelas';

    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public override canShow: Record<string, boolean> = {};

    public override model = {} as ParcelasModel;

    public totalSupSigpac = 0;

    public totalSupCultivada = 0;

    public clients_width_parcelas = ['covidai', 'pyf', 'almassora', 'agricar', 'jobarma', 'prodalbar', 'agrosalvi'];

    public anchoNombre = this.clients_width_parcelas.includes(this.appName) ? '220px' : '120px';

    public showAllParcelas = false;

    public mapaOpened = false;

    public mapaAbierto = false;

    public origin = 'parcelas';

    public finca = 'finca';

    public localidad = 'localidad';

    public cultivo = 'cultivo';

    public variedad = 'variedad';

    public parcelaNombre = 'nombre parcela';

    public coordenadas = 'coordenadas parcela';

    public cultivoField = (this.hasPlantas && !this.showCultivosVariedadesPropios) ? 'cultivo_legacy' : 'cultivo';

    public variedadField = (this.hasPlantas && !this.showCultivosVariedadesPropios) ? 'variedad_legacy' : 'variedad';


    public cols: ColInterface[] = [
        { field: 'id_finca', header: 'Nº Finca', filter: '', width: '140px', visible: this.showNumeroFincas },
        { field: 'finca', header: this.fincaName, width: '140px', filter: '', visible: this.showParcelasFincasCol },
        { field: 'sector', header: this.sectorName, width: '120px', filter: '', visible: this.showParcelasSector && this.showSectores },
        { field: 'nombre', header: 'Nombre ' + this.parcelaName, width: this.anchoNombre, filter: '', visible: this.showNombreParcela },
        { field: 'responsable_nombre', header: 'Grabador', width: '80px', filter: '', visible: this.appName === 'avafitogest' },
        { field: this.cultivoField, header: 'Cultivo', width: '100px', filter: '' },
        { field: this.variedadField, header: 'Variedad', width: '100px', filter: '' },
        { field: 'sistema_asesoramiento', header: 'S.A', width: '100px', filter: '', visible: this.appName === 'pyf' },
        { field: 'estacion_control', header: 'E.C', width: '100px', filter: '', visible: this.appName === 'pyf' },
        { field: 'partida', header: 'Partida', width: '100px', footer: '', visible: environment.features.showParcelasPartidasCol },
        { field: 'superficie_sigpac', header: 'Sup. SigPAC', width: '120px', footer: '' },
        { field: 'superficie_cultivada', header: 'Sup. Cultivada', width: '100px', footer: '' },
        { field: 'cod_provincia', header: 'Provincia', width: '100px', footer: '', visible: this.showParcelasProvinciaCol },
        { field: 'municipio', header: 'Municipio', width: '100px', footer: '', visible: this.showParcelasMunicipioCol },
        { field: 'poligono', header: 'Polígono', filter: '', width: '100px' },
        { field: 'numero', header: 'Nº Parcela', filter: '', width: '100px' },
        { field: 'recinto', header: 'Recinto', width: '100px', filter: '' },
        { field: 'prevision_produccion', header: 'Previsión Prod.', filter: '', visible: environment.appName === 'icod' },
        { field: 'activo', header: 'Activo', filter: '', width: '80px', visible: environment.features.showParcelasActivoCol },
        {
            field: 'aplicadores_nombre',
            header: 'Aplicadores',
            width: '80px',
            filter: '',
            visible: this.applicationType === 'cropgest' && this.appName !== 'avafitogest'
        },
        { field: 'gip', header: 'GIP', width: '80px', filter: '', visible: this.applicationType === 'cropgest' },
        { field: 'zona_riego', header: 'Zona de Riego', width: '80px', filter: '', visible: this.appName === 'avafitogest' }
    ];

    public selectedId = '';

    public selectedId_finca = '';



    constructor(
        public fincasApi: FincasApiService,
        public userApi: UsuariosApiService,
        public workersApi: TrabajadoresApiService,
        private readonly dashboard: DashboardService,
        private readonly router: Router,
        private readonly _http: HttpClient) {
        super(dashboard, fincasApi.parcelasGET, fincasApi.parcelasDELETE);
    }

    ngOnInit() {
        this.dashboard.setSubmenuItem(this.menuItemId);
        this.getRequest.response((res: ParcelasModel[]) => {

            const total: ParcelasModel[] = Object.create(res).filter((it: ParcelasModel) => it);

            this.totalSupSigpac = 0;
            this.totalSupCultivada = 0;
            total.forEach(parcela => {
                if (!isNaN((parseFloat(parcela.superficie_sigpac ?? '') + this.totalSupSigpac))) {
                    this.totalSupSigpac += parseFloat(parcela.superficie_sigpac?.replace(',', '.') ?? '');
                }

                if (!isNaN((parseFloat(parcela.superficie_cultivada ?? '') + this.totalSupCultivada))) {
                    this.totalSupCultivada += parseFloat(parcela.superficie_cultivada?.replace(',', '.') ?? '');
                }
            });

            this.totalSupSigpac =
                Utils.decimalFormat(this.totalSupSigpac, this.textoSuperficie.toLocaleUpperCase() === 'HA' ? 2 : 0) as unknown as number;
            this.totalSupCultivada =
                Utils.decimalFormat(this.totalSupCultivada, this.textoSuperficie.toLocaleUpperCase() === 'HA' ? 2 : 0) as unknown as number;


        });


        if (this.showCampaign) {
            this.filter.addFilter((copy: TreeNode<ParcelasModel>[] | void) =>
                (copy as TreeNode<ParcelasModel>[]).filter((row: TreeNode<ParcelasModel>) => {
                    if (this.selectedYears === '') {
                        return true;
                    } else {
                        return this.compareDates(row);
                    }
                }));
        }
        if (this.appName === 'pyf') {
            const storedYear = localStorage.getItem('selectedYear');

            if (storedYear) {
                // console.log('storedYear');
                this.selectedYears = storedYear;
            } else {
                const anyoActual = new Date().getFullYear();

                this.selectedYears = anyoActual.toString();
            }
            console.log(this.selectedYears);
            this.selectedCampaign(this.selectedYears);
        }
    }

    selectedCampaign(event: string) {
        const fixedEvent = event.replace(/^_+|_+$/g, '');

        localStorage.setItem('selectedYear', fixedEvent);

        if (this.appName === 'pyf' || this.appName === 'prosanzcu') {
            this.fincasApi.parcelasGET.toPromise({ p3: event, p4: 'filtro' } as never).then(res => {

                // this.filter.filtersToApply = [];

                this.filter.setValue(res as TreeNode<ParcelasModel>[]);
                return;
            }).catch(e => {
                console.log('catch en getPosition: ' + e);
            }
            );
        }
        this.filter.filter();
    }

    compareDates(row: TreeNode<ParcelasModel>) {
        const parcela = row as ParcelasModel;
        const finca = parcela.finca;
        const year = this.selectedYears.replace(/_/g, '');

        if (finca !== '' && finca.includes(year)) {
            return true;
        } else {
            return false;
        }
    }

    ngAfterViewInit() {
        this.fincasApi.parcelasGET.response(() => {
            this.updateFooter();
        });
    }

    listSiembra: TareaSiembraModel[] = [];

    showOpenModalHistoricoCultivo = false;

    colsHistoricoCultivo: ColInterface[] = [
        { field: 'fecha_inicio', header: 'Fecha inicio', filter: '' },
        { field: 'fecha_fin', header: 'Fecha fin', filter: '' },
        { field: 'cultivo', header: 'Cultivo', filter: '' },
        { field: 'variedad', header: 'Variedad', filter: '' },
    ];

    openHistoricoCultivo(model: ParcelasModel): void {
        this.showOpenModalHistoricoCultivo = true;
        this.listSiembra = model.historico_cultivos ?? [];
    }

    get listSiembraData(): TareaSiembraModel[] {
        return this.listSiembra;
    }

    public override show(modal: string, data: ParcelasModel): void {
        const currentData = data;

        if (this.appName === 'bravosol') {
            currentData.superficie_cultivada = Utils.decimalFormat(currentData.superficie_cultivada?.toString() ?? '', 3);
            currentData.superficie_sigpac = Utils.decimalFormat(currentData.superficie_sigpac?.toString() ?? '', 3);
        }

        this.selectedId = currentData.id;
        this.selectedId_finca = currentData.id_finca ? currentData.id_finca : '';

        super.show(modal, data);


        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;

        this.form = new ParcelasFormDefinition(formType, data as Record<string, string>, undefined, this.appendTable(data));
    }


    public eliminarParcelaCompleta(): void {
        const parcelaId = this.selectedId;
        const parcelaIdFinca = this.selectedId_finca;

        if (parcelaId && parcelaIdFinca) {
            const url = `${environment.serverUrl}ws/mapas/eliminaParcela.php?finca=${parcelaIdFinca}&parcela=${parcelaId}`;

            this._http.get(url, { responseType: 'text' })
                .subscribe(
                    res => {
                        if (!res.includes('ERROR')) {
                            alert('Parcela eliminada correctamente.');
                            this.filter.setValue(
                                (this.filter.value || []).filter(it => (it as ParcelasModel).id !== parcelaId)
                            );
                            this.updateFooter();
                        } else {
                            alert('Hubo un error eliminando la parcela.');
                        }
                    },
                    err => {
                        console.error('Error al eliminar la parcela:', err);
                        alert('Error conectando con el servidor.');
                    }
                );
        } else {
            console.log('Error al eliminar la parcela completamente');
        }

    }

    public add() {
        this.router.navigate(['dashboard', 'crear-parcela']);
    }


    public edit(data: ParcelasModel) {
        this.router.navigate(['dashboard', 'editar-parcela', data.id, data]);
    }

    public duplicate(data: ParcelasModel) {
        this.router.navigate(['dashboard', 'duplicar-parcela', data.id, data]);
    }


    public sistemaCultivoHumanTransform(field: ItemInterface<void>, model: ItemInterface<void>) {
        const self = model;

        self[field.field ?? ''] = [
            ['-', null],
            ['-', ''],
            ['Aire libre', '1'],
            ['Malla', '2'],
            ['Cubierta no accesible', '3'],
            ['Invernadero (cubierta accesible)', '4'],
            ['Forestales en rotación corta', '5'],
            ['Micorrizado', '6'],
            ['Acolchado (SG ACE)', '7'],
            ['Enarenado (SG ACE)', '8'],
            ['Bodega Sacos (Setas/champiñones)', '9'],
            ['Bodega Bandejas (Setas/champiñones)', '10'],
            ['Bodega Botellas (Setas/champiñones)', '11'],
            ['Bodega Otros (Setas/champiñones)', '12'],
            ['Nave Sacos (Setas/champiñones)', '13'],
            ['Nave Bandejas (Setas/champiñones)', '14'],
            ['Nave Botellas (Setas/champiñones)', '15'],
            ['Nave Otros (Setas/champiñones)', '16'],
            ['Hoyos (Viñedo Lanzarote)', '17'],
            ['Zanjas (Viñedo Lanzarote)', '18'],
            ['Invernadero (cubierta accesible)+ enarenado', '19'],
        ]
            .filter(data => self[field.field ?? ''] === data[1])
            .map(data => data[0]).toString();

        return self;
    }

    public observacionesForestalesHumanTransform(field: ItemInterface<void>, model: ItemInterface<void>) {
        const self = model;

        self[field.field ?? ''] = [
            ['-', null],
            ['-', ''],
            ['EUCALIPTO', '225'],
            ['PAULONIA', '200'],
            ['CHOPO', '116'],
            ['SAUCE', '227'],
            ['ROBINIA', '230'],
            ['MIMBRERA', '442'],
        ]
            .filter(data => self[field.field ?? ''] === data[1])
            .map(data => data[0]).toString();

        return self;
    }

    public secanoRegadioHumanTransform(field: ItemInterface<void>, model: ItemInterface<void>) {
        const self = model;

        self[field.field ?? ''] = [
            ['-', null],
            ['-', ''],
            ['Secano', 'S'],
            ['Regadio', 'R']
        ]
            .filter(data => self[field.field ?? ''] === data[1])
            .map(data => data[0]).toString();

        return self;

    }

    public sistemaRiegoHumanTransform(field: ItemInterface<void>, model: ItemInterface<void>) {
        const self = model;

        self[field.field ?? ''] = [
            ['-', null],
            ['-', ''],
            ['Superficie o Gravedad', '1'],
            ['Aspersión fija', '2'],
            ['Aspersión móvil', '3'],
            ['Microaspersión', '4'],
            ['Nebulización', '5'],
            ['Goteo', '6'],
            ['Hidropónico a solución perdida', '7'],
            ['Hidropónico con recirculación de solución', '8'],
        ]
            .filter(data => self[field.field ?? ''] === data[1])
            .map(data => data[0]).toString();

        return self;
    }

    public sistemaAsesoramientoHumanTransform(field: ItemInterface<void>, model: ItemInterface<void>) {
        const self = model;

        self[field.field ?? ''] = [
            ['-', null],
            ['-', ''],
            ['Agricultura Ecológica', 'AE'],
            ['Producción Integrada', 'PI'],
            ['Certificación Privada', 'CP'],
            ['Agrupación de Tratamiento Integrado en Agricultura', 'ATRIAS'],
            ['Asistida de un Asesor', 'AS'],
            ['Sin obligación de aplicar la GIP', 'NO'],
            ['Agrupación Oficial Reconocida', 'AO'],
            ['Asesor Individual', 'AI'],
            ['Guías de cultivo', 'GC']
        ]
            .filter(data => self[field.field ?? ''] === data[1])
            .map(data => data[0]).toString();

        return self;
    }

    getSelectedNodes(event: any): void {
        this.selectedNodes.set(event);
    }

    activatedAssign(): void {
        this.multiSelect.set(!this.multiSelect());
        this.tableMode.set(this.multiSelect() ? 'checkbox' : 'single');

    }

    openAssignToResponsible(): void {
        this.assignToResponsibleOpened = !this.assignToResponsibleOpened;
        // this.getUsersList();
    }

    openAssignToAdvisor(): void {
        this.assignToAdvisorOpened = !this.assignToAdvisorOpened;
        // this.getWorkersListByRoleAdvisor();
    }

    assignToAdvisor(): void {
        const selectedAdvisor = this.selectedAdvisor;
        const selectedParcels = this.selectedNodes().map(it => (it.data as ParcelasModel).id);

        const postParams = {
            id_advisor: selectedAdvisor,
            ids_parcelas: selectedParcels
        };

        this._http.put(`${environment.serverUrl}ws/index.php?p1=parcelas&p2=assign_advisor`, postParams)
            .subscribe(
                (res: any) => {

                    if (res.statusCode === 202) {
                        alert('Asesor asignado correctamente.');

                        this.assignToAdvisorOpened = false;
                        this.selectedNodes.set([]);
                        this.multiSelect.set(false);
                        this.tableMode.set('single');

                        window.location.reload();
                    }
                }
            );
    }

    assignToResponsible(): void {
        const selectedUsers = this.selectedResponsable;
        const selectedParcels = this.selectedNodes().map(it => (it.data as ParcelasModel).id);

        const postParams = {
            id_responsible: selectedUsers,
            ids_parcelas: selectedParcels
        };

        this._http.put(`${environment.serverUrl}ws/index.php?p1=parcelas&p2=assign_responsible`, postParams)
            .subscribe(
                (res: any) => {

                    if (res.statusCode === 202) {
                        alert('Responsable asignado correctamente.');
                        this.assignToResponsibleOpened = false;
                        this.selectedNodes.set([]);
                        this.multiSelect.set(false);
                        this.tableMode.set('single');
                    }
                }
            );
    }

    public getUsersList(): void {
        this.userApi.usuariosGET.toPromise({ p3: 'active' } as never).then(res => {
            this.responsables.set(res.filter((item) => item.rol !== 'admin') as UserModel[]);
        }).catch(e => {
            console.log('catch en getUsersList: ' + e);
        });
    }

    public getWorkersListByRoleAdvisor(): void {
        this.workersApi.trabajadoresGET.toPromise({ p3: 'advisor' } as never).then(res => {
            this.workersAdvisors.set(res.filter((item) => item.tipo_carnet?.includes('ASESOR')) as MantenimientoModel[]);
        }).catch(e => {
            console.log('catch en getWorkersListByRoleAdvisor: ' + e);
        });
    }

    public globalConditionalStyle(value: string, col: ColInterface): ColStylesInterface {

        if ((Utils.isNumber(value) &&
            (col.field !== 'sector' && col.field !== 'nombre')) ||
            col.field === 'superficie_sigpac' || col.field === 'superficie_cultivada') {
            return {
                textAlign: 'center',
                paddingRight: '60px',
            };
        } // if();

        if (col.field === 'poligono' ||
            col.field === 'numero' ||
            ['activo'].includes(col.field)) {
            return {
                textAlign: 'center',
            };
        }// if();

        return { textAlign: 'center' };
    }

    public globalVisualTransform(value: string, col: ColInterface, row: TreeNode<ParcelasModel>) {
        const parcela = row.data as ParcelasModel;

        if (Utils.isNumber(value)) {
            if (col.field === 'superficie_cultivada' || col.field === 'superficie_sigpac') {
                if (this.textoSuperficie !== 'Ha') {
                    return Utils.decimalFormat((value || '').replace(',', '.'), 2);
                }
                return Utils.decimalFormat((value || '').replace(',', '.'), 2).replace('.', ',');
            } else if (col.field === 'plantas') {
                return Utils.decimalFormat(value, 0);
            }
        }

        if (col.field === 'activo') {
            return ([1, true, '1'].includes(value)) ? 'Sí' : 'No';
        }

        if (col.field === 'finca' && this.applicationType === 'cropgest' && this.rol !== 'user') {
            return parcela.cliente + '-' + value;
        }

        if (col.field === 'gip') {
            switch (value.toString()) {
                case '1':
                    return 'Sí';
                case '2':
                    return 'No';
                case '3':
                    return 'No';
                default:
                    return 'No';
            }
        }

        return value;
    }

    public override sum(field: string) {
        let sum = 0;

        (this.filter.value || []).forEach(it => {
            if (!isNaN((parseFloat((it as ParcelasModel)[field]?.toString() ?? '') + sum))) {
                sum += parseFloat((it as ParcelasModel)[field]?.toString().replace(',', '.') ?? '');
            }
        });

        this.cols.forEach(it => {
            if (it.field === field) {

                it.footer = this.textoSuperficie.toLocaleUpperCase() === 'HA' ?
                    Utils.decimalFormat(sum + '', 2) :
                    Utils.decimalFormat(sum + '', 0);
            }
        });
    }

    public override updateFooter() {
        ['superficie_sigpac', 'superficie_cultivada'].forEach(it => { this.sum(it); });
    }

    nuevoRecinto(recinto: { id: string; convertido: number; coordenadas: string }) {
        let coordenadasOK = '';
        let puntoYcoma = '';
        let coordenadas: string = recinto.coordenadas;

        coordenadas = coordenadas.replace(/\(/g, '[');
        coordenadas = coordenadas.replace(/\)/g, ']');
        const coordinates = coordenadas.split(';');

        coordinates.map(coor => {
            const sinComa = coor.split(',');

            if (sinComa[0] && sinComa[1]) {
                const unaCoordenada = [
                    (sinComa[0] as string).substring(1, sinComa[0].length), (sinComa[1] as string).substring(0, sinComa[1].length - 1)
                ];
                const nuevasCoor = convierteEPSG(unaCoordenada);

                coordenadasOK += puntoYcoma + '(' + nuevasCoor[1] + ',' + nuevasCoor[0] + ')';
                puntoYcoma = ';';
            }
        });
        recinto.coordenadas = coordenadasOK;
        return recinto;
    }

    public abreMapa(
        data: {
            finca: string;
            localidad: string;
            cultivo: string;
            variedad: string;
            nombre: string;
            mapa: { coordenadas: string; }[];
        }) {
        this.mapaOpened = true;
        this.mapaAbierto = !this.mapaAbierto;
        this.finca = data.finca ?? '';
        this.localidad = data.localidad ?? '';
        this.cultivo = data.cultivo ?? '';
        this.variedad = data.variedad ?? '';
        this.parcelaNombre = data.nombre ?? '';
        this.coordenadas = data.mapa[0]?.coordenadas ?? '';
    }

    public async conversionEPSG() {

        /*         this._http.get(environment.serverUrl+'ws/index.php?p1=generic&p2=recintos').subscribe(recintos =>{
            console.log({recintos});
            
        }) */

        const recintos = await firstValueFrom(
            this._http.get<{ data: { id: string; convertido: number; coordenadas: string }[] }>
                (environment.serverUrl + 'ws/index.php?p1=generic&p2=recintosb'));


        recintos.data.filter((recinto: { id: string; convertido: number; coordenadas: string }) =>
            recinto.convertido = 0).map((recinto: { id: string; convertido: number; coordenadas: string }) => {

                recinto = this.nuevoRecinto(recinto);
                recinto.convertido = 1;
                const body = {
                    coordenadas: recinto.coordenadas,
                    convertido: 1
                };

                const headers = new HttpHeaders();

                headers.append('Content-Type:', 'application/json');
                headers.append('Request-Method', 'PUT');

                firstValueFrom(this._http.put(
                    environment.serverUrl + 'ws/index.php?p1=generic&p2=recintosb&p3=' + recinto.id,
                    JSON.stringify(body),
                    { headers: headers }
                ));


            });


        return;


        //convierteEPSG([-672280.535474339, 4616629.0602604905]);
    }

    public changeShowAll() {
        if (this.showAllParcelas) {
            this.fincasApi.parcelasGET.toPromise({ p3: 1 } as never).then(res => {
                this.filtering?.setValue(res as TreeNode<ParcelasModel>[]);
                return;
            }).catch(e => {
                console.log('catch en getPosition: ' + e);
            }
            );
        } else {
            this.fincasApi.parcelasGET.toPromise({ p3: 0 } as never).then(res => {
                this.filtering?.setValue(res as TreeNode<ParcelasModel>[]);
                return;
            }).catch(e => {
                console.log('catch en getPosition: ' + e);
            }
            );
        }
        this.filtering?.filter();
    }

    public downloadCsv(): void {
        this.form = new ParcelasFormDefinition(
            +FormType.EXPORT,
            this.filtering.value as unknown as Record<string, string>,
            undefined,
            null
        );
        const csvContent = createCsv(this.form.fieldNames, this.form.fieldLabels, this.filtering.value as ParcelasModel[]);
        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement;

        csvLink.download = this.form.formFields.name + '.csv';
        csvLink.href = encodeURI(csvContent);
        csvLink.click();
    }// ();

    public getFromMapa(datos: string) {
        const data = JSON.parse(datos);

        if (this.appName !== 'amoros') {
            this.model.cod_provincia = data.provincia;
            this.model.municipio = data.municipio;
            this.model.poligono = data.poligono;
            this.model.numero = data.parcela;
            this.model.recinto = data.recinto;
            this.model.superficie_sigpac = data.ha;
            this.model.sigpac = data.refpar;
            this.model.uso_sigpac = data.usoSigpac;
        }

        if (!this.model.mapa) {
            this.model.mapa = [{} as FullMapModel];
        }

        if (this.model.mapa[0]) {
            this.model.mapa[0].id_finca = this.model.id_finca ?? '';
            this.model.mapa[0].id_sector = this.model.id_sector ?? '';
            this.model.mapa[0].id_cultivo = (this.activateApiSIEX ? this.model.id_cultivo_legacy : this.model.id_cultivo) ?? '';
            this.model.mapa[0].id_usuario = StorageManager.getUser().id;
            this.model.mapa[0].coordenadas = data.coord;
            this.model.mapa[0].color = data.color;

            if (this.parcelaNombre !== '' && this.parcelaNombre != null) {
                this.model.nombre = this.parcelaNombre;
            } else {
                this.model.nombre = `${this.parcelaName} ${data.parcela}`;
            }

        }
        this.mapaAbierto = false;
    }

    openDocumentInNewTab(): void {
        window.open('https://locatec.es/proyectos/fitogest/documentos_consulta/lista-de-cultivos-exentos-asesoramiento.pdf', '_blank');
    }

    private appendTable(model: ParcelasModel): [string[][], string[]] {
        const columns = [
            'Fecha Inicio',
            'Fecha Fin',
            'Cultivo',
            'Variedad'
        ];

        const data = model.historico_cultivos ?? [];

        const table: string[][] = [[]];
        const rowStyles: string[] = [];

        for (let row = 0; row <= data.length; row++) {
            if (row === 0) {
                table[row] = columns;
                rowStyles.push('');
            } else {
                const campaign = data?.[row - 1];

                const rowData = [
                    campaign?.fecha_inicio ?? '',
                    campaign?.fecha_fin ?? '',
                    campaign?.cultivo ?? '',
                    campaign?.variedad ?? '',
                ];

                table[row] = rowData;
            }
        }
        return [table, rowStyles];
    }
}